import { getHttpClient, errorDesconocido } from "../../../../core/utils/httpClient";
import basicList from "../../../../core/redux/actions/list";

import queryString from "query-string";

const PREFIX = "MANAGER_PURCHASE_ORDER_FORM";
const getState = (state) => state.manager.purchaseOrder.form;

const {
    /**
     * Main request & reset
     */
    getListPattern,
    listReset: reset,

    secondaryGetPattern,
    secondaryPostPattern,
    secondaryPutPattern,

    /**
     * Element's actions
     */
    actionDeletePattern,
    actionPutPattern,

    /**
     * Selectores
     */
    getMeta,
    getList,
    getError,
    isLoaded,
    isLoading,
    isSecondaryLoading,
    getSecondarySuccess,
} = basicList(PREFIX, getState);

export const list = (queryParams) => {
    /**
     * Add hidden parameters to make the API call
     */
    const hiddenParams = { uncompensatedVendor: 1 };

    /**
     * It's also possible to remove and sanitize some parameters
     */
    const customQueryParams = { ...queryParams, ...hiddenParams };

    /**
     * Call to the API
     */
    return getListPattern("react/v1/tasks", customQueryParams);
};

export const listForVendor = (queryParams, vendorId) => {
    /**
     * Add hidden parameters to make the API call
     */
    const hiddenParams = { uncompensatedVendor: 1, vendorId: vendorId };

    /**
     * It's also possible to remove and sanitize some parameters
     */
    const customQueryParams = { ...queryParams, ...hiddenParams };

    /**
     * Call to the API
     */
    return getListPattern("react/v1/tasks", customQueryParams);
};

export { reset, getMeta, getList, getError, isLoaded, isLoading, isSecondaryLoading, getSecondarySuccess };

export const createCPO = (form, queryParams) => {
    const hiddenParams = { uncompensatedVendor: 1 };

    const customQueryParams = { ...queryParams, ...hiddenParams };

    const search = queryString.stringify(customQueryParams, { arrayFormat: "bracket" });

    return secondaryPostPattern("manager/purchase-orders/v1/?" + search, form, {
        message: "Generated",
        description: "The purchase orders were generated.",
    });
};

export const assignTask = (purchaseOrderId, taskId) => {
    return secondaryPutPattern(
        "manager/purchase-orders/v1/" + purchaseOrderId + "/assign-task/" + taskId,
        {},
        {
            message: "Purchase Order",
            description: "The Task was assigned.",
        }
    );
};
